var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriving(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Driving_svg__a{fill:none;stroke:#24a81b;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Driving_svg__a",
    d: "M36.667 15L32.3 16.667M7.716 16.667L3.333 15M30.417 23.334H26.25M13.75 23.334H9.583M32.298 16.667l-1.4-6.687a4.169 4.169 0 00-4.079-3.313H13.353a4.166 4.166 0 00-4.057 3.218l-1.585 6.782M5.416 33.334h3.75a2.5 2.5 0 002.5-2.5v-1.667h16.667v1.667a2.5 2.5 0 002.5 2.5h3.75a2.084 2.084 0 002.083-2.083v-9.584a5 5 0 00-5-5H8.333a5 5 0 00-5 5v9.583a2.084 2.084 0 002.083 2.084z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z",
    fill: "none"
  })));
}
export default SvgDriving;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Driving.svg
// module id = 707
// module chunks = 11